import {Component, OnInit} from '@angular/core';
import {Constants} from '../Services/Constants';
import {HTTPService} from '../Services/http.service';
import {Observable}   from 'rxjs/Observable';
import {filter} from '../App/search.pipe';
import {DatePipe} from "@angular/common";
import {MySharedService} from '../App/shared.service'

declare function ExportToExcel(item: any[], workSheetName: string, keys: any,Columns?: any): void;

@Component({
    templateUrl: './AppViews/ProjectFinancialReport/projectFinancialReport.html'  
})

export class ProjectFinancialReportComponent implements OnInit {
    constants:Constants;
    projectFinancialItems:any=[];
    teamItems:any[];
    projectTypeItems:any=[];   
    userDetail: any;
    selfuser:boolean=true;
    filter:any={'TeamId':"",'TypeId':"",'Year':moment().format('YYYY')};
    Search:any;
    public showLoader = false;
    
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _datepipe: DatePipe){
        this.constants = new Constants();
         this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
         this.filter.TeamId = '';
    }

     ngOnInit(){
         this.BindFilters();        
         this.GetProjectFinancial(true);
     }

     ExportItems(){
        var exportList=JSON.parse(JSON.stringify(this.projectFinancialItems));;
        var fil=new filter();
        exportList=fil.transform(exportList,this.Search);
        ExportToExcel(exportList, "Project Financial",
        ["ProjectCode","ProjectYear" ,"Customer_Name", "Project_Title", "ProjectTypeName", "Value", "TPCurrencyName", "ProjectValue", "ValueCurrencyName","TotalUserCost",
            "PendingPayment"],
        ["Project Code","Project Year" ,"Customer Name", "Project Title", "Project Type Name", "Service Value", "TPCurrency Name", "Full Project Value", "Value Currency Name", "Total User Cost","Pending Payment"]);
    } 

    GetProjectFinancial(flag:boolean){
         this.selfuser=flag;
         var TeamId = 0;
         if(this.filter.TeamId == "")
         {
             TeamId = this.userDetail.TeamID;
         }
         else
         {
             TeamId = this.filter.TeamId;
         }
         	 this.showLoader=true;
            this._httpService.ajaxPost("ProjectFinancial/GetProjectFinancialReport",
            {"Project_Id":0,"Team_Id":TeamId,"Project_Type":this.filter.TypeId,"ProjectYear":this.filter.Year,"User_Id":this.userDetail.SiteUserId}).subscribe(
                data =>{
                    this.projectFinancialItems=data["ProjectFinancialList"];
                    var str=this.userDetail.TeamID;
                     
                   if(str.includes('1')&&str.includes('2')&&str.includes('3')&&str.includes('4')){
               
                 this.projectFinancialItems.forEach(element => {

                
                        element.IsVisibleCurrency=true
                        element.IsVisibleTransfer=true
                        element.IsVisiblePending =true
                         })
                    }
                    else{
                        
                        
                   if(str.includes('1')||str.includes('3'))
                       { 
                        
                        this.projectFinancialItems.forEach(element => {

                            if(element.ProjectValue_Currency==1)
                       { element.IsVisibleCurrency=true
                        element.IsVisibleTransfer=false
                        element.IsVisiblePending =false
                       }
                        if(element.ProjectValue_Currency==2)
                       { element.IsVisibleCurrency=false
                        element.IsVisibleTransfer=true
                        element.IsVisiblePending =false
                       }
                         if(element.ProjectValue_Currency==3)
                       { element.IsVisibleCurrency=false
                        element.IsVisibleTransfer=true
                        element.IsVisiblePending =false
                       }
                      })
                     }

                         if(str.includes('2')||str.includes('4'))
                       { 
                        
                        this.projectFinancialItems.forEach(element => {

                    if(element.ProjectValue_Currency==2)
                       { element.IsVisibleCurrency=true
                         element.IsVisibleTransfer=false
                         element.IsVisiblePending =false
                       }
                        if(element.ProjectValue_Currency==1)
                       { element.IsVisibleCurrency=false
                         element.IsVisibleTransfer=true
                         element.IsVisiblePending =false
                       }
                         if(element.ProjectValue_Currency==3)
                       { element.IsVisibleCurrency=false
                        element.IsVisibleTransfer=true
                        element.IsVisiblePending =false
                       }
                      })
                     }
                    }
                    
                },
                err => {
                    console.log("GetProjectFinancial Failed");
                       this.showLoader=false;
                      this._sharedService.ShowMessage(this.constants.globalError);    
         
                },
                () =>{
                      console.log("GetProjectFinancial "+ this.selfuser);        
                      	 this.showLoader=false;
              
                }
            );      
    }

    ngAfterViewInit() {
        
        $(".dateYear").datetimepicker({
            format: 'YYYY'
        }); 
        $(".datemonthYear").datetimepicker({
            format: 'MM/YYYY'
        });     
        $(".time").datetimepicker({
            format: 'HH:mm'
        });
        $("#show-filter").click(function(){$(".filter-form").slideToggle()});
    }
    BindFilters(){
         this.showLoader=true;
      this._httpService.ajaxPost('Team/GetAssignedTeam', {"TeamId":this.userDetail.TeamID,"UserId":this.userDetail.SiteUserId}).subscribe(
           data =>{
             this.teamItems=data["AssignedTeam"];  
          },
          err => {
              console.log("BindFilters Failed");
                 this.showLoader=false;
              this._sharedService.ShowMessage(this.constants.globalError);
         
          },
          () =>{
              	 this.showLoader=true;
              this._httpService.ajaxPost('Common/GetParameter', 
              { "ParameterTypeId" : this.constants.enumParamterTypeName["ProjectType"] }).subscribe(
                    data => {
                        this.projectTypeItems = data["Parameter"];
                    },
                    err => {
                            this.showLoader=false;
                        console.log("BindFilters Failed");
                        this._sharedService.ShowMessage(this.constants.globalError);
        
                    },
                    			 
() =>{			 this.showLoader=false;
             
				}
              );
              	 this.showLoader=false;
                
            }
        );
    }

    public clearFilter(){
        this.filter.TypeId = "";
      this.filter.TeamId = "";
        this.filter.Year = "";
        this.Search="";
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ProjectFinancialReport/projectFinancialReport.component.ts
 **/